import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';

@Component({
  selector: 'app-job-organization',
  templateUrl: './job-organization.component.html',
  styleUrls: ['./job-organization.component.scss'] // Corrected 'styleUrl' to 'styleUrls' and ensure the path is correct.
})
export class JobOrganizationComponent implements OnInit {
  organizationId: number; // Added to store the organization ID
  organizations: any[] = [];
  jobs: any[] = []; // Directly store jobs for a specific organization
  isLoadingJobs: boolean = true; // Initialize loading flag to true

  constructor(private apiService: ApiService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.fetchOrganizationId();
    this.fetchOrganizations();
  }

  fetchOrganizationId(): void {
    this.route.paramMap.subscribe(params => {
      this.organizationId = +params.get('id'); // '+' converts string to number
      if (this.organizationId) {
        this.fetchJobsByOrganization(this.organizationId);
      }
    });
  }

  fetchOrganizations(): void {
    
    this.apiService.getOrganizationsWithJobs().subscribe({
      next: (data) => {
        this.organizations = data;
       
      },
      error: (error) => console.error('Error fetching organizations:', error)
    });
  }

  fetchJobsByOrganization(organizationId: number): void {
    this.isLoadingJobs = true;
    this.apiService.getJobsByOrganization(organizationId).subscribe({
      next: (data) => {
        this.jobs = data; // Store jobs for the specific organization
        this.isLoadingJobs = false;
      },
      error: (error) => console.error(`Error fetching jobs for organization ID ${organizationId}:`, error)
    });
  }

  isLoggedIn(): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }

    try {
      const decoded: any = jwtDecode(token);
      return decoded.exp > Date.now() / 1000;
    } catch (error) {
      console.error('Error decoding token:', error);
      return false;
    }
  }

  filterJobs(orgCode: string): void {
    if (orgCode === 'all') {
      // Navigate to the job list route
      this.router.navigateByUrl('/job-list');
    } else {
      // Assume orgCode is equivalent to organizationId for this example
      // You might need to adjust based on your actual data structure
      const selectedOrg = this.organizations.find(org => org.id === orgCode);
      if (selectedOrg) {
        this.router.navigateByUrl(`/organization/${selectedOrg.id}`);
      }
    }
  }
}
